import { AnalyticsWindow } from "./analytics-window"
import setUserProperties from "./analytics-identify"
import { getFromLocalStorage } from "../../utils/local-storage"

declare let window: AnalyticsWindow

function get6senseData() {
  const dataLoaded = window.dataLayer?.find(
    item => item?.event === "6si_company_details_loaded",
  )
  if (!dataLoaded) return {}
  const localStorageData = getFromLocalStorage("_6senseCompanyDetails")
  const companyDetails = localStorageData?.company || {}
  const segmentDetails = localStorageData?.segments || {}
  let data = {
    Company: companyDetails.name,
    Industry: companyDetails.industry,
    "Employee count": companyDetails.employee_count,
    "Employee range": companyDetails.employee_range,
    "Annual revenue": companyDetails.annual_revenue,
    Title: companyDetails.titleLevel,
    Function: companyDetails.titleFunction,
    "Revenue range": companyDetails.revenue_range,
    "HQ region": companyDetails.region,
    Segments: segmentDetails.names,
  }
  const filteredData = Object.entries(data).reduce(
    (acc: Record<string, any>, [key, value]) => {
      if (value && value.length > 0) {
        acc[key] = value
      }
      return acc
    },
    {},
  )
  return { "6sense": [filteredData] }
}

function set6senseDataOnUserProperty() {
  setUserProperties(get6senseData())
}

export { set6senseDataOnUserProperty }
export default get6senseData
